module.exports = __webpack_public_path__ + "static/img/kjscsb@2x.ec726ea3.png";